import { GetDocumentsActions, GetRcuDocumentsActions } from "./GetDocumentsAction";

const initialState = {
  loading: false,
  showDocuments: [],
  RcuShowDocuments: [],
};

const getDocumentReducer = (state = initialState, action) => {
  switch (action.type) {
    case GetDocumentsActions.GET_DOCUMENTS_LOADING:
      return {
        ...state,
        loading: true,
      }

    case GetDocumentsActions.GET_DOCUMENTS_SUCCESS:
      return {
        ...state,
        showDocuments: action.payload,
        loading: false,
      };

    case GetDocumentsActions.GET_DOCUMENTS_ERROR:
      return {
        ...state,
        showDocuments: [],
        loading: false,
      };


    case GetRcuDocumentsActions.GET_RCU_DOCUMENTS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case GetRcuDocumentsActions.GET_RCU_DOCUMENTS_SUCCESS:
      return {
        ...state,
        RcuShowDocuments: action.payload,
        loading: false,
      };

    case GetRcuDocumentsActions.GET_RCU_DOCUMENTS_ERROR:
      return {
        ...state,
        RcuShowDocuments: [],
        loading: false,
      };


    default:
      return state;
  }
};

export default getDocumentReducer;
